import { render, staticRenderFns } from "./TabDefaultValues.vue?vue&type=template&id=4621f470&scoped=true"
import script from "./TabDefaultValues.vue?vue&type=script&lang=js"
export * from "./TabDefaultValues.vue?vue&type=script&lang=js"
import style0 from "./TabDefaultValues.vue?vue&type=style&index=0&id=4621f470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4621f470",
  null
  
)

export default component.exports